// Click off of sidebar to close it
document.addEventListener('click', function(event) {
    const sidebar = document.querySelector('.App-sidebar');
    const addButton = document.querySelector('.add-activity-button');
    const datePopup = document.querySelector('.MuiPaper-elevation8'); // MUI DatePicker popup
    if (datePopup && datePopup.contains(event.target)) {
        return; // Ignore clicks inside the date picker popup
    }
    if (sidebar && !sidebar.contains(event.target) && !addButton.contains(event.target)) {
        sidebar.classList.remove('open');
    }
});